import { render } from "./MenuOption.vue?vue&type=template&id=5c227b4e&scoped=true"
import script from "./MenuOption.vue?vue&type=script&lang=js"
export * from "./MenuOption.vue?vue&type=script&lang=js"

import "./MenuOption.vue?vue&type=style&index=0&id=5c227b4e&scoped=true&lang=css"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c227b4e"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../../../../oarus-app/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon});
